import { create } from 'zustand'

import { PopoverStoreState } from './types'

export const usePopoverStore = create<PopoverStoreState>((set) => ({
  activeId: null,
  setActiveId: (activeId: string | null) => set({ activeId }),
}))
